import { Helmet } from 'react-helmet-async';
import {
  getDefaultSEO,
  getOrganizationSchema,
  getSoftwareApplicationSchema,
  getFAQSchema,
} from '../utils/seo';

/**
 * SEO Component
 * Manages meta tags, Open Graph, Twitter Cards, and structured data for the landing page.
 */
const SEO = ({ title, description, keywords, canonical, ogImage, noindex = false }) => {
  const base = getDefaultSEO();

  const seo = {
    title: title || base.title,
    description: description || base.description,
    keywords: keywords || base.keywords,
    canonical: canonical || base.canonical,
    ogTitle: base.ogTitle,
    ogDescription: base.ogDescription,
    ogImage: ogImage || base.ogImage,
    twitterImage: base.twitterImage,
  };

  // Allow environment-based indexing control (matches REACT_APP_ROBOTS_INDEX)
  const blockIndex = noindex || process.env.REACT_APP_ROBOTS_INDEX !== 'true';

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />

      {seo.canonical && <link rel="canonical" href={seo.canonical} />}

      {blockIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph */}
      <meta property="og:title" content={seo.ogTitle} />
      <meta property="og:description" content={seo.ogDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:image" content={seo.ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Solidly Meet" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.ogTitle} />
      <meta name="twitter:description" content={seo.ogDescription} />
      <meta name="twitter:image" content={seo.twitterImage} />

      {/* Structured Data */}
      <script type="application/ld+json">{JSON.stringify(getOrganizationSchema())}</script>
      <script type="application/ld+json">{JSON.stringify(getSoftwareApplicationSchema())}</script>
      <script type="application/ld+json">{JSON.stringify(getFAQSchema())}</script>
    </Helmet>
  );
};

export default SEO;
